import { jsx as s, jsxs as O } from "react/jsx-runtime";
import { getCellType as C, cellTypeMap as L } from "../tools.js";
import { tv as m } from "../../tailwind-variants.config.js";
import { motion as b } from "framer-motion";
import { Tooltip as M } from "../../Tooltip/index.js";
const R = m({
  base: "jm-group",
  variants: {
    isRowLoading: {
      true: "jm-animate-deep-pulse jm-bg-jutro-new-blue-50"
    },
    isDisabled: {
      false: "hover:jm-bg-jutro-new-blue-50 active:jm-bg-jutro-new-blue-100"
    },
    isRowSelected: {
      true: "jm-bg-jutro-new-blue-200 hover:jm-bg-jutro-new-blue-100"
    },
    isRowOpened: {
      true: "jm-bg-jutro-new-blue-300 hover:jm-bg-jutro-new-blue-300"
    },
    isSingleSelectionMode: {
      true: "jm-cursor-pointer"
    },
    isGrouped: {
      true: "jm-sticky jm-left-0 jm-z-1 jm-cursor-pointer jm-bg-jutro-new-warm-gray-50 hover:jm-bg-jutro-new-warm-gray-50 active:jm-bg-jutro-new-warm-gray-50"
    }
  }
}), T = m({
  extend: R,
  variants: {
    isGrouped: {
      true: "jm-top-[52px]"
    }
  }
}), N = m({
  extend: R,
  variants: {
    isGrouped: {
      true: "jm-top-11"
    }
  }
}), H = (t) => {
  var j;
  const { row: e, rows: f, index: h, isRegularSize: r, disabled: d, selectionRowMode: c } = t, l = c === "multiple", n = c === "single", g = (() => {
    var i;
    return l ? !!t.selectedRows.find(({ id: o }) => o === e.original.id) : n ? ((i = t.selectedRow) == null ? void 0 : i.id) === e.original.id : !1;
  })(), x = h === f.length - 1, S = (i) => {
    if (!l)
      return;
    const { selectedRows: o, setSelectedRows: a } = t, p = o.find(({ id: u }) => u === i.original.id);
    if (p) {
      const u = o.filter(
        ({ id: G }) => G !== p.id
      );
      a(u);
      return;
    }
    a([...o, i.original]);
  }, y = !n && t.withOpen && ((j = t.openedRow) == null ? void 0 : j.id) === e.original.id, I = "getIsRowLoading" in t && t.getIsRowLoading ? t.getIsRowLoading(e.original) : !1, w = {
    isGrouped: e.getIsGrouped(),
    isSingleSelectionMode: n,
    isRowSelected: e.getIsGrouped() ? !1 : g,
    isDisabled: e.getIsGrouped() ? !0 : !!d,
    isRowOpened: e.getIsGrouped() ? !1 : y,
    isRowLoading: I
  }, v = r ? T(w) : N(w);
  return /* @__PURE__ */ s(
    M,
    {
      content: e.original.tooltip,
      disabled: !e.original.tooltip,
      position: "right-end",
      openedTooltipClassName: "jm-bg-jutro-new-blue-50",
      trigger: /* @__PURE__ */ O(
        "tr",
        {
          className: v,
          onClick: () => {
            e.getToggleExpandedHandler()(), !(e.getIsGrouped() || d) && (n && t.setSelectedRow(g ? null : e.original), !n && t.withOpen && t.setOpenedRow(
              (i) => i === e.original ? null : e.original
            ));
          },
          children: [
            e.getVisibleCells().map((i) => {
              const o = C(i, l), a = L[o];
              return /* @__PURE__ */ s(
                b.td,
                {
                  className: `jm-align-top ${r ? "jm-px-3" : "jm-px-2"}`,
                  initial: { padding: 0 },
                  animate: {
                    padding: r ? "12px" : "8px"
                  },
                  exit: { padding: 0 },
                  transition: { duration: 0.3, ease: "easeInOut" },
                  children: /* @__PURE__ */ s(
                    b.div,
                    {
                      initial: { opacity: 0, height: 0 },
                      animate: {
                        opacity: 1,
                        height: "auto"
                      },
                      exit: { opacity: 0, height: 0 },
                      transition: { duration: 0.3, ease: "easeInOut" },
                      children: /* @__PURE__ */ s(
                        a,
                        {
                          row: e,
                          cell: i,
                          isRowSelected: g,
                          handleChange: S,
                          isRegularSize: r,
                          isMultipleSelectionMode: l,
                          disabled: d
                        }
                      )
                    }
                  )
                },
                i.id
              );
            }),
            e.getIsGrouped() && !x && /* @__PURE__ */ s("div", { className: "jm-absolute jm-inset-x-0 jm-bottom-0 jm-h-px jm-bg-jutro-new-warm-gray-200" })
          ]
        }
      )
    }
  );
};
export {
  H as Row
};
//# sourceMappingURL=index.js.map
